var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("border-content border-content-" + _vm.direction),style:(("float:" + _vm.direction + ";width:" + _vm.width))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }